import React from 'react';
import { render } from 'react-dom';
import 'current-input';
import './injectGlobal';

import configureStore from './configureStore';
import Root from './modules/core/Root';
/*
import { reactopt } from 'reactopt';
if (process.env.NODE_ENV === 'development') {
  reactopt(React);
}
*/
const store = configureStore();

render(<Root store={store} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js